import description from "../../assets/svg/description.svg";
import process from "../../assets/svg/process-icon.svg";
import group from "../../assets/svg/group-des.svg";
import amazon from "../../assets/svg/checkout-icon.svg";
import packages from "../../assets/svg/package-icon.svg";
import archive from "../../assets/svg/archive-icon.svg";
import deliveryTruck from "../../assets/images/delivery-truck-blue.png";
import moneyBag from "../../assets/images/money-bag.png";
import driverLicense from "../../assets/images/driver-license.png";
import demoIcon from "../../assets/images/demo-icon.png";
import packageIcon from "../../assets/images/package-icon.png";
import clockGroup from "../../assets/images/clock-group.png";
import groupOrder from '../../assets/images/group-order.png';
import groupPickups from '../../assets/images/group-pickups.png';
import groupReturns from '../../assets/images/group-returns.png';
import groupShipment from '../../assets/images/group-shipment.png';
import groupCarts from '../../assets/images/group-carts.png';

import theme from "../../theme";

export const statisticsTitles = {
  totalRequestsMade: "Total Requests Made",
  ordersCompleted: "Orders Completed",
  ordersInProgress: "Orders In Progress",
  awaitingPaymentApproval: "Awaiting Payment Approval",
  pendingConfirmationFromShopper: "Pending Confirmation from Shopper",
  nextEstimatedDelivery: "Next Estimated Delivery",

  todaysOrder: "Today’s Order",
  pickups: "Pickups",
  returns: "Returns",
  shipment: "Shipment",
  groupCarts: "Group Carts",

  totalLocker: "Total Locker",

  verifiedToday: "Verified Today",
  pendingApproval: "Pending Approvals",
  totalPendingItems: "Total Pending Number",
  rejectedItems: "Rejected Items",
  itemsAddedToLocker: "Items on Locker",

  totalCustomers: "Total Customers",
  activeUsers: "Active Users",
  pendingVerification: "Pending Verification",

  totalShoppers: "Total Shoppers",
  activeShoppers: "Active Shoppers",

  totalPackagesPacked: "Total Packages Packed",
  packagesAwaitingDispatch: "Packages Awaiting Dispatch",
  shippingCostPaid: "Shipping Cost Paid",
  pendingShippingPayment: "Pending Shipping Payment",
  trackingIDsActive: "Tracking IDs Active",
  shippingPartnerAssigned: "Shipping Partner Assigned",

  orderPlaced: "Order Placed",
  orderCollectedFromSelf: "Order collected from Self",
  readyForPacking: "Ready for Packing",
  deliveredToWarehouse: "Delivered to Warehouse",
};

export const orderData = [
  {
    title: statisticsTitles.totalRequestsMade,
    value: "42",
    icon: description,
  },
  {
    title: statisticsTitles.ordersCompleted,
    value: "42",
    icon: amazon,
  },
  {
    title: statisticsTitles.ordersInProgress,
    value: "42",
    icon: process,
  },
  {
    title: statisticsTitles.awaitingPaymentApproval,
    value: "42",
    icon: group,
  },
  {
    title: statisticsTitles.pendingConfirmationFromShopper,
    value: "42",
    icon: archive,
  },
  {
    title: statisticsTitles.nextEstimatedDelivery,
    value: "42",
    icon: packages,
  },
];

export const adminStatisticsData = [
  {
    title: statisticsTitles.todaysOrder,
    value: "0",
    icon: groupOrder,
  },
  {
    title: statisticsTitles.totalRequestsMade,
    value: "0",
    icon: groupPickups,
  },
  {
    title: statisticsTitles.ordersCompleted,
    value: "0",
    icon: groupReturns,
  },
  {
    title: statisticsTitles.ordersInProgress,
    value: "0",
    icon: groupShipment,
  },
  {
    title: statisticsTitles.totalCustomers,
    value: "0",
    icon: groupCarts,
  },
];

export const adminProductIntakeStatisticsData = [
  {
    title: statisticsTitles.totalPendingItems,
    value: "0",
    icon: process,
  },
];

export const productStatisticsData = [
  {
    title: statisticsTitles.verifiedToday,
    value: "1234",
    icon: description,
  },
  {
    title: statisticsTitles.pendingApproval,
    value: "1332",
    icon: process,
  },
  {
    title: statisticsTitles.rejectedItems,
    value: "42",
    icon: group,
  },
  {
    title: statisticsTitles.itemsAddedToLocker,
    value: "42",
    icon: group,
  },
];

export const customerStatisticsData = [
  {
    title: statisticsTitles.totalCustomers,
    value: "1234",
    icon: description,
  },
  {
    title: statisticsTitles.activeUsers,
    value: "1332",
    icon: process,
  },
  {
    title: statisticsTitles.pendingVerification,
    value: "42",
    icon: group,
  },
];

export const shopperStatisticsData = [
  {
    title: statisticsTitles.totalShoppers,
    value: "0",
    icon: description,
  },
  {
    title: statisticsTitles.activeShoppers,
    value: "0",
    icon: process,
  },
  {
    title: statisticsTitles.pendingVerification,
    value: "0",
    icon: group,
  },
];

export const orderStatisticsData = [
  {
    title: statisticsTitles.todaysOrder,
    value: "1234",
    icon: description,
  },
];

export const lockerStatisticsData = [
  {
    title: statisticsTitles.totalLocker,
    value: "1234",
    icon: description,
  },
];

export const packingData = [
  {
    title: statisticsTitles.totalPackagesPacked,
    value: 42,
    icon: packageIcon,
  },
  {
    title: statisticsTitles.packagesAwaitingDispatch,
    value: 40,
    icon: deliveryTruck,
  },
  {
    title: statisticsTitles.shippingCostPaid,
    value: "02",
    icon: moneyBag,
  },
  {
    title: statisticsTitles.pendingShippingPayment,
    value: 40,
    icon: clockGroup,
  },
  {
    title: statisticsTitles.trackingIDsActive,
    value: 40,
    icon: driverLicense,
  },
  {
    title: statisticsTitles.shippingPartnerAssigned,
    value: "John",
    isdemo: true,
    icon: demoIcon,
  },
];

export const shipments = [
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "In Transit",
    price: "1500 USD",
    weight: "150 KGs",
    color: "primary",
    backgroundColor: "#46BBFF",
    highlight: true,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delayed",
    price: "1500 USD",
    weight: "150 KGs",
    color: "error",
    delayed: true,
    backgroundColor: "#FF3850",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delivered",
    price: "1500 USD",
    weight: "150 KGs",
    color: "success",
    deliverChip: true,
    backgroundColor: "#00C046",

    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
];

export const shipmentsOrder = [
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "In Transit",
    price: "1500 USD",
    weight: "150 KGs",
    color: "primary",
    backgroundColor: "#46BBFF",
    highlight: true,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delayed",
    price: "1500 USD",
    weight: "150 KGs",
    color: "error",
    delayed: true,
    backgroundColor: "#FF3850",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delivered",
    price: "1500 USD",
    weight: "150 KGs",
    color: "success",
    deliverChip: true,
    backgroundColor: "#00C046",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delayed",
    price: "1500 USD",
    weight: "150 KGs",
    color: "error",
    delayed: true,
    backgroundColor: "#FF3850",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delivered",
    price: "1500 USD",
    weight: "150 KGs",
    color: "success",
    deliverChip: true,
    backgroundColor: "#00C046",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delayed",
    price: "1500 USD",
    weight: "150 KGs",
    color: "error",
    delayed: true,
    backgroundColor: "#FF3850",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
  {
    id: "#023125-5562",
    date: "20-March-2025",
    status: "Delivered",
    price: "1500 USD",
    weight: "150 KGs",
    color: "success",
    deliverChip: true,
    backgroundColor: "#00C046",
    highlight: false,
    from: "Chennai, India (MAA)",
    to: "Vancouver International Airport (YVR)",
  },
];

export const invitaionData = [
  {
    groupName:"Group A",
    username:"Rishabh",
  },
  {
    groupName:"Group B",
    username:"Rishabh",
  },
  {
    groupName:"Group C",
    username:"Rishabh",
  },
  {
    groupName:"Group D",
    username:"Rishabh",
  },
]

export const deliverySteps = [
  {
    date: "20-March-2025, Wednesday",
    status: statisticsTitles.orderPlaced,
    color: "primary",
  },
  {
    date: "20-March-2025, Wednesday",
    status: statisticsTitles.orderCollectedFromSelf,
    color: "warning",
  },
  {
    date: "22-March-2025, Wednesday",
    status: statisticsTitles.readyForPacking,
    color: "warning",
  },
  {
    date: "22-March-2025, Wednesday",
    status: statisticsTitles.deliveredToWarehouse,
    color: "success",
    faded: true,
  },
];

export const colorMap = {
  primary: theme.palette.custom.primary,
  warning: theme.palette.custom.warning,
  success: theme.palette.custom.success,
};
